type KeyString = {
  [key: string]: string
}

export const ALERT_STATUS_OBJECT: KeyString = {
  'AUTO-FALSE-POSITIVE': 'Falso positivo automático',
  'AUTO-CONCLUDED': 'Conclusão automática',
  'FALSE-POSITIVE': 'Inconclusivo',
  INCONCLUSIVE: 'Falso positivo',
  IDENTIFIED: 'Identificado',
  OPEN: 'Em aberto',
  INVESTIGATING: 'Em atendimento',
  CONCLUDED: 'Concluido',
  DELETED: 'Deletado',
  GONE: 'Removido',
}
